export default __webpack_public_path__ + "static/media/1917-cineplex.cdd27b52.jpg";